import { AlertCircle, CreditCard, X } from 'lucide-react';
import { useState } from 'react';

export default function SubscriptionWarning({ warning, subscription, onClose }) {
  const [dismissed, setDismissed] = useState(false);

  if (!warning || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    if (onClose) onClose();
  };

  const getWarningColor = () => {
    if (warning.type === 'expired') return 'red';
    if (warning.daysLeft <= 3) return 'red';
    if (warning.daysLeft <= 7) return 'amber';
    return 'blue';
  };

  const color = getWarningColor();

  return (
    <div className={`bg-${color}-50 dark:bg-${color}-900/20 border-2 border-${color}-200 dark:border-${color}-800 rounded-lg p-4 mb-4 animate-pulse`}>
      <div className="flex items-start gap-3">
        <AlertCircle className={`w-6 h-6 text-${color}-600 dark:text-${color}-400 flex-shrink-0 mt-0.5`} />
        
        <div className="flex-1">
          <h4 className={`font-semibold text-${color}-700 dark:text-${color}-300 mb-1`}>
            {warning.type === 'expiring' ? '⚠️ Assinatura Vencendo!' : '🚨 Assinatura Vencida!'}
          </h4>
          
          <p className={`text-sm text-${color}-600 dark:text-${color}-400 mb-3`}>
            {warning.message}
          </p>

          {subscription && (
            <div className={`text-xs text-${color}-600 dark:text-${color}-400 space-y-1 mb-3`}>
              <p>📋 Plano: <strong>{subscription.plan.toUpperCase()}</strong></p>
              <p>💰 Valor: <strong>R$ {subscription.price.toFixed(2)}/mês</strong></p>
              <p>📅 Vencimento: <strong>{new Date(subscription.nextPaymentDate).toLocaleDateString()}</strong></p>
            </div>
          )}

          <div className="flex gap-2">
            <button className={`px-4 py-2 bg-${color}-600 hover:bg-${color}-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center gap-2`}>
              <CreditCard className="w-4 h-4" />
              Renovar Agora
            </button>
            
            <button
              onClick={handleDismiss}
              className={`px-3 py-2 bg-${color}-100 dark:bg-${color}-800 text-${color}-700 dark:text-${color}-300 rounded-lg text-sm hover:bg-${color}-200 dark:hover:bg-${color}-700 transition-colors`}
            >
              Lembrar Depois
            </button>
          </div>
        </div>

        <button
          onClick={handleDismiss}
          className={`text-${color}-500 hover:text-${color}-700 dark:hover:text-${color}-300 transition-colors`}
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}


